import React from 'react'
import { Tag, Tooltip } from 'antd'
import { useIntl } from 'react-intl'
import { PTOSuggestion } from '../../EnergyLevelPage/types'
import { formatShortDate } from '../utils/formatShortDate'

interface IMemberPtoSuggestionCardProps {
  suggestion: PTOSuggestion
  isBestOption: boolean
}

const PRIORITY_CLASS: Record<string, string> = {
  critical: 'te-suggestion-card__pill--high',
  high: 'te-suggestion-card__pill--high',
  medium: 'te-suggestion-card__pill--medium',
  low: 'te-suggestion-card__pill--low',
}

const MemberPtoSuggestionCard: React.FC<IMemberPtoSuggestionCardProps> = ({ suggestion, isBestOption }) => {
  const { formatMessage, locale } = useIntl()
  const priority = suggestion.recommendation?.priority
  const pillClass = priority ? (PRIORITY_CLASS[priority] ?? 'te-suggestion-card__pill--default') : 'te-suggestion-card__pill--default'
  const holidays = suggestion.holidaysIncluded ?? []

  return (
    <div className={`te-suggestion-card${isBestOption ? ' te-suggestion-card--best' : ''}`}>
      <div className="te-suggestion-card__header">
        <div className="te-suggestion-card__range">{`${formatShortDate(suggestion.startDate, locale)} – ${formatShortDate(suggestion.endDate, locale)}`}</div>
        {isBestOption && <Tag className={`te-suggestion-card__pill ${pillClass}`}>{formatMessage({ id: 'teamEnergy.memberDetail.bestOption' })}</Tag>}
      </div>
      <div className="te-suggestion-card__summary">
        {formatMessage({ id: 'teamEnergy.memberDetail.daysOffSummary' }, { daysOff: suggestion.durationDays, ptoDays: suggestion.ptoDaysUsed })}
      </div>
      {holidays.length > 0 && (
        <div className="te-suggestion-card__meta">
          <Tooltip title={holidays.map((h) => h.name).join(', ')}>
            <span className="te-suggestion-card__meta-item te-suggestion-card__meta-item--holiday">
              🎉{' '}
              {holidays.length === 1
                ? formatMessage({ id: 'teamEnergy.memberDetail.includesHoliday' }, { name: holidays[0].name })
                : formatMessage({ id: 'teamEnergy.memberDetail.includesHolidays' }, { count: holidays.length })}
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default MemberPtoSuggestionCard
